import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { FeatureInformation, getFeatureInformation } from './access-restricted-content';
import { FeatureInfoService } from './feature-info.service';
import { FeatureInfo, getFeatureInfo } from './restricted-content/restricted-content';
// import { Feature } from '../core/access';

// Use this list deploy the new lockscreens one at a time.
const v2Templates = [
  // Feature.myProducts,
  // Feature.vendastaPayments,
];

@Component({
  templateUrl: './access.component.html',
  styleUrls: ['./access.component.scss'],
})
export class AccessRestrictedComponent implements OnInit {
  backgroundImageUrl =
    'url("https://vstatic-prod.apigateway.co/partner-center-client.9223372035141236080.prod/assets/images/restricted-bg.png")';

  // old feature info

  // old feature info
  featureInfo$: Observable<FeatureInformation>;
  // new feature info
  featureInfoV2$: Observable<FeatureInfo>;

  // TODO: Remove once we have deployed the new feature info
  showV2Template$ = this.route.params.pipe(
    map((params) => {
      const featureId = params.featureId;
      return v2Templates.includes(featureId);
    }),
  );

  backgroundImageUrlSanitized: SafeStyle;

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private readonly featureInfoService: FeatureInfoService,
  ) {}

  ngOnInit(): void {
    let featureId: string;

    // the new restricted pages
    this.featureInfoV2$ = this.route.params.pipe(
      map((params) => {
        featureId = params.featureId;
        return getFeatureInfo(featureId);
      }),
    );

    // the old restricted pages
    this.featureInfo$ = this.route.params.pipe(
      switchMap((params) => {
        featureId = params.featureId;
        return this.featureInfoService.getNextSubscriptionTierWithFeature(featureId);
      }),
      map((nextSubscriptionId) => {
        const featureInfo = getFeatureInformation(featureId);
        featureInfo.minUpgradeLevel = nextSubscriptionId;
        return featureInfo;
      }),
    );
    this.backgroundImageUrlSanitized = this.sanitizer.bypassSecurityTrustStyle(this.backgroundImageUrl);
  }
}
